import { useNavigate } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import './ProviderTableRow.scss';
import { formatProviderName, getProviderUrl } from '../../helpers/providers';
import { MAX_WITH_MOBILE_MEDIA } from '../../config/getTheme';

const ProviderTableRow = props => {
  const { provider: p } = props;
  const navigate = useNavigate();

  return (
    <Stack
      flexDirection='row'
      justifyContent='space-between'
      padding={0.5}
      className='ProviderTableRow'
      onClick={() => navigate(getProviderUrl(p))}
    >
      <Stack flexDirection='row' className='ProviderItem__avatar-text'>
        <Avatar
          className='ProviderItem__avatar'
          variant="square"
          src={p.imgSrc || p.public_profile_img_url}
          alt={`${p.firstName} ${p.lastName}`}
        />
        <Stack
          justifyContent='space-between'
          padding={0.5}
        >
          <Typography
            variant='large500Tight'
            color='text.primary'
            sx={{
              lineHeight: 'normal',
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              display: "-webkit-box",
              whiteSpace: "normal",
              marginBottom: '4px',
            }}
          >
            {formatProviderName(p)}
          </Typography>
          <Typography
            variant='normal'
            color='text.light'
            sx={{
              lineHeight: 'normal',
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
              display: "-webkit-box",
            }}
          >
            {p.city}{p.state ? `, ${p.state}` : ''}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        className='ProviderItem__button-stack'
        direction={{ xs: 'column', sm: 'row' }}
        alignItems='center'
        justifyContent='center'
      >
        <Button
          variant='primaryOutline'
          size='small'
          sx={{
            whiteSpace: 'nowrap'
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/clients/messages/${p.id}`);
          }}
        >
          <Typography
            variant='small'
            color='text.blue'
            sx={{
              [MAX_WITH_MOBILE_MEDIA]: {
                fontSize: '0.6875rem',
              },
            }}
          >
            Send Message
          </Typography>
        </Button>

        <Button
          variant='primaryOutline'
          size='small'
          sx={{
            whiteSpace: 'nowrap'
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/clients/appointments/new/${p.id}`);
          }}
        >
          <Typography
            variant='small'
            color='text.blue'
            sx={{
              [MAX_WITH_MOBILE_MEDIA]: {
                fontSize: '0.6875rem',
              },
            }}
          >
            Schedule Now
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};

export default ProviderTableRow;
